import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import * as TicketSoldService from './../services/ticketSoldService';
import * as TicketSoldAction from '../actions/ticketSoldAction';

function* getListTicketSold() {
    yield takeLatest(Types.TICKET_SOLD_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(TicketSoldService.getTicketSold, params);
        yield put(TicketSoldAction.setTicketSold(result.data));
    }, errorHandleUser(Types.TICKET_SOLD_LIST_FAIL)))
}

function errorHandleUser(errorActionType) {
    return Func.sagaErrorHandler(function* (e){
        yield put({ type: errorActionType })
    }, 'ticketSold');
}

export function* ticketSoldSaga() {
    yield all([
        fork(getListTicketSold)
    ])
}
